<template>
  <layout-empty>
    <slot></slot>
  </layout-empty>
</template>

<script lang="ts">
  import Vue from 'vue';
  import LayoutEmpty from './layout-empty.vue';

  export default Vue.extend({
    name: 'LayoutWidgetNoDesign',
    components: {
      LayoutEmpty,
    },
    props: {

    },
    data: () => ({

    }),
  });
</script>
